export default "__VITE_ASSET__B7IR022p__"